import styled from 'styled-components';
import { ButtonProps } from '.';

export enum ButtonSize {
    ssm = 'ssm',
    sm = 'sm',
    md = 'md',
    lg = 'lg',
}

const sizes = {
    ssm: 0.65,
    sm: 0.85,
    md: 1,
    lg: 1.3,
};

export const StyledButton = styled.button<ButtonProps>`
    background: ${(props) => props.backgroundColor};
    color: ${(props) => props.color};
    height: ${({ size }) => sizes[size || ButtonSize.md] * 40}px;
    border-radius: 3px;
    min-width: 70px;
    cursor: pointer;
    padding: 0 30px;
    font-size: 14px;
    border: none;
    transition: all 300ms ease;
    outline: none;

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    &:hover:not(:disabled) {
        box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.18),
            0 2px 7px 0 rgba(0, 0, 0, 0.15);
        border-color: transparent;
        background: ${(props) => props.backgroundColor};
    }
`;

export const StyledButtonOutline = styled(StyledButton)`
    background: #fff;
    border: 2px ${(props) => props.backgroundColor} solid;
    color: ${(props) => props.color};

    &:hover:not(:disabled) {
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.18),
            0 1px 4px 0 rgba(0, 0, 0, 0.15);
        border: 2px ${(props) => props.backgroundColor} solid;
        background: #fff;
    }
`;
